export default __webpack_public_path__ + "static/media/boxTokenBg.f22cd3f4.png";